// BeeLove — Badge System
import { getEffectiveTranslations } from './i18n';

function t(lang, key) {
  return getEffectiveTranslations(lang||'en')[key] || key;
}

export function getPillars(lang) {
  return {
    authenticity: { label: t(lang,'pillar.authenticity'), color: '#C9A84C' },
    engagement:   { label: t(lang,'pillar.engagement'),   color: '#7EB8A0' },
    lucidity:     { label: t(lang,'pillar.lucidity'),      color: '#A084C9' },
    social:       { label: t(lang,'pillar.social'),        color: '#C97A7A' },
    evolution:    { label: t(lang,'pillar.evolution'),     color: '#7AA8C9' },
  };
}
export const PILLARS = getPillars('en');

export function getBadges(lang) {
  return [
    { id:'verified',      name:t(lang,'badge.verified_name'), desc:t(lang,'badge.verified_desc'),  pillar:'authenticity', type:'foundation', public:'always', icon:'verified',      condition:u=>!!(u.verified) },
    { id:'mirror',        name:t(lang,'badge.mirror_name'),   desc:t(lang,'badge.mirror_desc'),    pillar:'authenticity', type:'foundation', public:true,     icon:'mirror',        condition:u=>!!(u.quiz_answers&&Object.keys(u.quiz_answers).length>=5&&u.friend_ratings&&Object.keys(u.friend_ratings).length>0) },
    { id:'honest',        name:t(lang,'badge.honest_name'),   desc:t(lang,'badge.honest_desc'),    pillar:'authenticity', type:'foundation', public:true,     icon:'honest',        condition:u=>!!(u.bio&&u.bio.length>20&&u.prompts&&u.prompts.filter(p=>p?.a).length>=2) },
    { id:'active',        name:t(lang,'badge.active_name'),   desc:t(lang,'badge.active_desc'),    pillar:'engagement',   type:'living',     public:true,     icon:'active',        condition:u=>u.lastActive==='Online'||u.lastActive==='Today'||u.lastActive?.includes('h ago') },
    { id:'conversational',name:t(lang,'badge.convo_name'),    desc:t(lang,'badge.convo_desc'),     pillar:'engagement',   type:'living',     public:true,     icon:'conversational',condition:(u,s)=>!!(s&&s.activeConversationRate>=0.6) },
    { id:'aligned',       name:t(lang,'badge.aligned_name'),  desc:t(lang,'badge.aligned_desc'),   pillar:'lucidity',     type:'foundation', public:true,     icon:'aligned',       condition:(u,s)=>!!(s&&s.coherenceScore>=80) },
    { id:'conscious',     name:t(lang,'badge.selfaware_name'),desc:t(lang,'badge.selfaware_desc'), pillar:'lucidity',     type:'foundation', public:false,    icon:'conscious',     condition:u=>!!(u.hasViewedCoherence) },
    { id:'anchored',      name:t(lang,'badge.anchored_name'), desc:t(lang,'badge.anchored_desc'),  pillar:'social',       type:'foundation', public:true,     icon:'anchored',      condition:u=>!!(u.friend_ratings&&Object.keys(u.friend_ratings).length>=3) },
    { id:'connector',     name:t(lang,'badge.connector_name'),desc:t(lang,'badge.connector_desc'), pillar:'social',       type:'foundation', public:true,     icon:'connector',     condition:u=>!!(u.invitesSent>=5&&u.friend_ratings&&Object.keys(u.friend_ratings).length>=3) },
    { id:'growing',       name:t(lang,'badge.growing_name'),  desc:t(lang,'badge.growing_desc'),   pillar:'evolution',    type:'living',     public:true,     icon:'growing',       condition:u=>!!(u.hasImprovedCoherence) },
  ];
}
export const BADGES = getBadges('en');

export function computeBadges(user, stats={}, lang) {
  return getBadges(lang).map(badge=>({ ...badge, earned:badge.condition(user,stats) }));
}

export function getPublicBadges(user, stats={}, lang) {
  const earned = computeBadges(user, stats, lang).filter(b=>b.earned);
  const userVisible = user.visibleBadges||[];
  const always  = earned.filter(b=>b.public==='always');
  const chosen  = earned.filter(b=>b.public===true&&userVisible.includes(b.id));
  const combined = [...always,...chosen];
  if (combined.length<3) {
    const auto = earned.filter(b=>b.public===true&&!combined.find(c=>c.id===b.id));
    combined.push(...auto.slice(0,3-combined.length));
  }
  return combined.slice(0,3);
}

export function badgeColor(pillar, lang) {
  return getPillars(lang)[pillar]?.color||'var(--gold)';
}

export function computeCoherence(user) {
  if (!user.friend_ratings||!user.criteria_scores) return null;
  const dims = Object.keys(user.friend_ratings);
  if (dims.length<3) return null;
  const diffs = dims.map(k=>{
    const self   = (user.criteria_scores[k] ?? 5) / 10;
    const friend = (user.friend_ratings[k]   ?? 5) / 10;
    return Math.abs(self-friend);
  });
  const avgDiff = diffs.reduce((a,b)=>a+b,0)/diffs.length;
  return Math.round((1-avgDiff)*100);
}
